import { data } from "autoprefixer";
import * as HttpService from "./http.service";
import * as URL from "./url.service";

export const createSoftBlockedResource = (data) => {
    return HttpService.postWithAuth(URL.CREATE_SOFT_BLOCKED_RESOURCE_URL, data);
}

export const unblockSoftBlockedResource = (softBlockedResourceId, data) => {
    return HttpService.putWithAuth(URL.UNBLOCK_SOFT_BLOCKED_RESOURCE_URL(softBlockedResourceId), data)
}

export const extendSoftBlockedResource = (softBlockedResourceId, data) => {
    return HttpService.putWithAuth(URL.EXTEND_SOFT_BLOCKED_RESOURCE_URL(softBlockedResourceId), data)
}

export const getSoftBlockShiftTimingsBySoftblockId = ({ softblockId }) => {
    return HttpService.getWithAuth(URL.GET_SOFTBLOCK_SHIFT_TIMINGS_BY_SOFTBLOCK_ID({ softblockId }));
}
